<template>
  <div :style="{height: '100vh'}" class="search-view">
    <div :class="getHeaderClass" ref="searchHeader">
      <div class="button-area" @click.prevent="onClickBackButton">
        <span class="a11y-hidden">뒤로 가기</span>
        <BackButton/>
      </div>
      <div class="search-box-area">
        <input type="text" placeholder="검색어를 입력해 주세요" class="input-search"
               @focus.prevent="onFocusSearchInput($event)"
               @keypress.enter="enter"
               :value="searchKeyword"
               ref="searchKeyword"
               v-on:input="searchKeyword = $event.target.value" v-on:keyup="getRecommendation"
               maxlength="50"
        >
        <button v-if="searchKeyword!==''" @click.prevent="clickCancelInput()" class="search-delete">
          <img src="/img/common/delete-input.png" alt="입력 취소"/>
        </button>
      </div>
      <template v-if="tagSearchKeywordList.length > 0">
        <!-- 영화, VOD 에서 태그를 클릭해서 들어 왔을때 -->
        <template v-if="tagSearchFilterIndex !== null">
          <div class="tag-search-list">
            <div class="flex-wrapper">
              <div v-for="(tag, index) in tagSearchKeywordList"
                   :key="tag.text+index"
                   :class="tagSearchFilterIndex === index ? 'tag-item selected' : 'tag-item'"
                   @click.prevent="()=>setFilterTagResult(tag)">
                #{{tag.text}}
              </div>
            </div>
          </div>
        </template>
        <!-- 검색에서 태그를 선택 했을때 -->
        <template v-else>
          <div class="tag-search-list">
            <div class="flex-wrapper">
              <div class="tag-item"
                   @click.prevent="()=>deleteTagOne(tag)"
                   v-for="(tag, index) in tagSearchKeywordList"
                   :key="tag.text+index">
                <span class="tag-item-txt">{{tag.text}}</span>
                <div class="delete-tag-icon">
                  <TagDeleteButton/>
                </div>
              </div>
            </div>
          </div>
          <div class="tag-refresh">
            <div class="tag-refresh-button" @click.prevent="reSelectTag">
              <span class="tag-refresh-icon"><RefreshTagListButton/></span> 태그 재검색
            </div>
          </div>
        </template>
        <tag-search-result-tab :current-tag-search-result-tab="currentTagSearchResultTab" :change-tag-tab="changeTagTab"></tag-search-result-tab>

      </template>
      <!-- 사용자 입력에 따른 검색 결과, 과거 검색 내역에서의 검색 했을때 헤더의 탭 메뉴-->
      <template v-if="isVisibleSearchResult && tagSearchKeywordList.length === 0">
        <keyword-search-result-tab></keyword-search-result-tab>
      </template>
    </div>
    <!-- header end -->
    <div class="search-wrapper" ref="searchWrapper">
      <div class="search-inner-wrapper" ref="searchInnerWrapper">
        <h1 class="a11y-hidden">웨이브</h1>
        <!-- 여기서 검색했는지 여부 -->

        <!-- 최근 검색어 -->
        <recent-search-keyword v-if="!isVisibleCategorySearch && !isVisibleTagSearch"
                               :is-visible-empty-search-keyword="isVisibleEmptySearchKeyword"
                               :vod-keyword-list-info="vodKeywordListInfo"
                               :movie-keyword-list-info="movieKeywordListInfo"
                               :search-keyword="searchKeyword"
        ></recent-search-keyword>
        <!-- 추천 검색, 검색결과 -->
        <div v-if="isVisibleRecommendTagKeyword"
             :class="tagSearchKeywordList.length ? 'search-result with-tag-list' : 'search-result search-result-intro'">
          <!-- 처음 들어왔을때 추천 태그 검색 목록 -->
          <recommend-search-keyword-list v-if="isVisibleRecommendTagKeyword"/>
        </div>
        <!-- 사용자 입력, 기존검색 결과로 인한 검색 결과 -->
        <div v-else-if="isVisibleSearchResult" :class="getSearchResultClass">
          <search-result-band-view :keyword="searchKeyword" :change-keyword="changeKeyword" :last-keyword="lastKeyword" :search-by-change-keyword="searchByChangeKeyword"></search-result-band-view>
        </div>
        <!-- 태그 검색 결과 -->
        <div v-else-if="isVisibleTagSearchResult"
             id="tagtest" :class="tagSearchFilterIndex === null ?'search-result with-tag-list' : 'search-result with-tag-list with-filter'">
          <tag-search-result-band-view></tag-search-result-band-view>
        </div>
      </div>
      <!-- 태그 검색-->
      <tag-search-view v-if="isVisibleTagSearch"
                       :prev-tag-list="tagSearchKeywordList"
                       :prev-tab-type="prevTagTab"
                       class="lnb-slide-duration"></tag-search-view>
    </div>
    <div class="search-bottom-menu" v-if="isVisibleBottomMenu" ref="bottomMenu">
      <search-bottom-menu v-if="isVisibleBottomMenu"/>
      <!--<search-bottom-menu v-if="!tagSearchKeywordList.length"/>-->
    </div>
</div>

</template>

<script>
// import vue100vh from 'vue-100vh'
import RecommedSearchKeywordList from '@/components/search/RecommendSearchKeywordList'
import SearchBottomMenu from '@/components/search/SearchBottomMenu'
import TagSearchView from '@/components/search/TagSearchView'
import { EventBus } from '@/components/eventbus/EventBus'
import { SearchService } from '@/common/api/api.service'
import { get, debounce, findIndex } from 'lodash'
import { mapGetters, mapMutations } from 'vuex'
import RecentSearchKeyword from '@/components/search/RecentSearchKeyword'
import TagSearchResultTab from '@/components/search/TagSearchResultTab'
import { LOCAL_STORAGE_PREV_SEARCH_KEY } from '@/common/constant'
import KeywordSearchResultTab from '@/components/search/KeywordSearchResultTab'
import TagSearchResultBandView from '@/components/search/TagSearchResultBandView'
import SearchResultBandView from '@/components/search/SearchResultBandView'
import BackButton from '@/assets/svg/common/ic_gnb_back_w.svg'
import TagDeleteButton from '@/assets/svg/common/ic-delete-tag.svg'
import RefreshTagListButton from '@/assets/svg/common/ic-replay-w.svg'
import { disableBodyScroll, enableBodyScroll } from '@/common/util/ui.utils'
import { getStorage } from '@/common/util/storage.util'
import utils from '@/common/util/utils'
import { isNaverBrowser, isTablet } from '@/common/util/ua'
import { isEmptyString, removePrefixEmptyString } from '@/common/util/common'
// import screenfull from 'screenfull'

export default {
  name: 'Search',
  props: ['closeSearch'],
  components: {
    KeywordSearchResultTab,
    RecentSearchKeyword,
    TagSearchResultBandView,
    // CategorySearchView,
    TagSearchView,
    TagSearchResultTab,
    SearchResultBandView,
    BackButton,
    TagDeleteButton,
    RefreshTagListButton,
    RecommendSearchKeywordList: RecommedSearchKeywordList,
    SearchBottomMenu: SearchBottomMenu
  },
  data () {
    return {
      searchKeyword: '',
      changeKeyword: '',
      vodKeywordListInfo: {},
      movieKeywordListInfo: {},
      storage: null,
      lastKeyword: '',
      originHeigth: 0
    }
  },
  methods: {
    ...mapMutations([
      'showTagSearch', 'hideTagSearch', 'setExternalInputSearchKeyword', 'setCurrentSearchResultTab',
      'showEmptySearchKeyword', 'hideEmptySearchKeyword', 'showBottomMenu', 'hideBottomMenu',
      'showRecommendTagKeyword', 'hideRecommendTagKeyword', 'deleteTag', 'changeTagTab',
      'setProgramTagSearchResult', 'setVodTagSearchResult', 'setMovieTagSearchResult', 'setTagSearchKeywordList',
      'showSearchResult', 'hideSearchResult', 'setPrevTagTab', 'setSearchResultMultiSectionList',
      'showTagSearchResult', 'hideTagSearchResult', 'setTagSearchFilterIndex', 'resetSearchState']),
    resetData () {
      this.searchKeyword = ''
      this.vodKeywordListInfo = {}
      this.movieKeywordListInfo = {}
      this.resetSearchState()
    },
    searchByChangeKeyword () {
      this.searchKeyword = this.changeKeyword
      this.searchByKeyword()
    },
    onFocusSearchInput () {
      if (this.searchKeyword === '' || this.searchKeyword.length === 0) {
        this.setTagSearchKeywordList([])
        this.hideBottomMenu()
        this.hideRecommendTagKeyword()
        this.hideTagSearchResult()
        this.showEmptySearchKeyword()
      }
      this.$refs['searchKeyword'].focus()
    },
    clickCancelInput () {
      this.showEmptySearchKeyword()
      this.searchKeyword = ''
      this.vodKeywordListInfo = {}
      this.movieKeywordListInfo = {}
      this.resetSearchState()
      this.$nextTick(() => {
        this.$refs['searchKeyword'].focus()
      })
    },
    onClickBackButton () {
      this.$router.back()
    },
    getRecommendation: debounce(function (e) { this.setRecommendation(e) }, 400),
    setRecommendation (e) {
      if (e.keyCode === 13) return
      if (this.searchKeyword === '' || this.searchKeyword.length === 0) {
        this.resetData()
        this.onFocusSearchInput()
      } else {
        SearchService.getRecommendKeywordByUserInput({ keyword: this.searchKeyword }).then(({ data }) => {
          this.vodKeywordListInfo = get(data, ['1'], null)
          this.movieKeywordListInfo = get(data, ['2'], null)
          // 검색결과 탭과 검색 결과리스트 안보이게
          this.hideEmptySearchKeyword()
          this.hideSearchResult()
        })
      }
    },
    deleteTagOne (tag) {
      this.deleteTag(tag)
      if (this.tagSearchKeywordList.length === 0) {
        this.showRecommendTagKeyword()
        this.showBottomMenu()
        return
      }
      this.setSearchTagData()
      if (this.currentTab !== 'all') {
        this.changeTagTab('all')
      }
    },
    reSelectTag () {
      this.changeTagTab('all')
      this.showTagSearch()
    },
    setKeywordHistoryToStorage (keyword) {
      let prevKeywordList = this.storage.get(LOCAL_STORAGE_PREV_SEARCH_KEY)
      if (prevKeywordList === null) {
        this.storage.set(LOCAL_STORAGE_PREV_SEARCH_KEY, keyword)
      } else {
        let prevArr = prevKeywordList.split(',')
        if (prevArr.indexOf(keyword) > -1) {
          const keywordIndex = prevArr.indexOf(keyword)
          const existKeyword = prevArr.splice(keywordIndex, 1)
          prevArr = existKeyword.concat(prevArr)
          this.storage.set(LOCAL_STORAGE_PREV_SEARCH_KEY, prevArr.join(','))
        } else {
          prevArr.unshift(keyword)
          this.storage.set(LOCAL_STORAGE_PREV_SEARCH_KEY, prevArr.join(','))
        }
      }
    },
    enter () {
      this.searchKeyword = removePrefixEmptyString(this.searchKeyword)
      if (this.searchKeyword.length === 0) return
      this.setKeywordHistoryToStorage(this.searchKeyword)
      this.searchByKeyword()
    },
    searchByKeyword () {
      if (this.searchKeyword === '') return
      this.$refs['searchKeyword'].blur()
      this.setExternalInputSearchKeyword(this.searchKeyword)
      this.lastKeyword = this.searchKeyword
      SearchService.keywordSearchCF({
        offset: 0,
        limit: 20,
        orderby: 'score',
        type: 'all',
        keyword: this.searchKeyword
      }).then(({ data }) => {
        setTimeout(
          () => {
            EventBus.$emit('change-keyword')
            this.changeKeyword = get(data, 'changekeyword', '')
            this.setSearchResultMultiSectionList(get(data, 'multisectionlist', []))
            this.hideEmptySearchKeyword()
            this.hideRecommendTagKeyword()
            this.vodKeywordListInfo = {}
            this.movieKeywordListInfo = {}
            this.showSearchResult()
          }, 500)
      })
    },
    setSearchTagData () {
      const getTagSearchKeywordList = (keywordList) => {
        if (this.tagSearchFilterIndex !== null) {
          return Object.assign([], keywordList).splice(this.tagSearchFilterIndex, 1)
        } else {
          return keywordList
        }
      }
      const sectionProgram =
          SearchService.tagSearch({
            limit: 20,
            offset: 0,
            orderby: 'score',
            type: 'program',
            searchtags: getTagSearchKeywordList(this.tagSearchKeywordList)
          })
      const sectionVod =
          SearchService.tagSearch({
            limit: 20,
            offset: 0,
            orderby: 'score',
            type: 'vod',
            searchtags: getTagSearchKeywordList(this.tagSearchKeywordList)
          })
      const sectionMovie =
          SearchService.tagSearch({
            limit: 20,
            offset: 0,
            orderby: 'score',
            type: 'movie',
            searchtags: getTagSearchKeywordList(this.tagSearchKeywordList)
          })
      this.axios.all([sectionProgram, sectionVod, sectionMovie])
        .then(this.axios.spread((programRes, vodRes, movieRes) => {
          // this.hideCategorySearch()
          this.hideTagSearch()
          this.hideRecommendTagKeyword()
          this.hideBottomMenu()
          const program = programRes.data
          const vod = vodRes.data
          const movie = movieRes.data
          program.title = '프로그램'
          program.count = get(program, ['cell_toplist', 'totalcount'], 0)
          program.viewMore = program.count > 20
          vod.title = '에피소드'
          vod.count = get(vod, ['cell_toplist', 'totalcount'], 0)
          vod.viewMore = vod.count > 20
          movie.title = '영화'
          movie.count = get(movie, ['cell_toplist', 'totalcount'], 0)
          movie.viewMore = movie.count > 20
          if (this.prevTagTab === 'movie') {
            program.count = 0
            vod.count = 0
          } else if (this.prevTagTab === 'vod') {
            movie.count = 0
          }
          this.setProgramTagSearchResult(program)
          this.setVodTagSearchResult(vod)
          this.setMovieTagSearchResult(movie)
        }))
    },
    setFilterTagResult (tag) {
      const newIndex = findIndex(this.tagSearchKeywordList, (t) => {
        return t.value === tag.value
      })
      this.setTagSearchFilterIndex(newIndex)
      this.setSearchTagData()
    },
    _onSearchByTag ({ searchTags, tabType }) {
      this.setPrevTagTab(tabType)
      this.setTagSearchKeywordList(searchTags)
      this.setSearchTagData(searchTags)
      this.showTagSearchResult()
    },
    _onSearchByRecentKeyword ({ keyword }) {
      this.setKeywordHistoryToStorage(keyword)
      this.searchKeyword = keyword
      this.setExternalInputSearchKeyword(keyword)
      this.hideSearchResult()
      this.searchByKeyword()
    },
    scrollKeyboard (origin) {
      if (origin === window.innerHeight) return
      this.$refs['searchKeyword'].blur()
    }
  },
  computed: {
    ...mapGetters(['isVisibleTagSearch', 'isVisibleEmptySearchKeyword',
      'isVisibleCategorySearch',
      'isVisibleBottomMenu', 'currentTagSearchResultTab', 'tagSearchKeywordList', 'prevTagTab',
      'isVisibleRecommendTagKeyword', 'isVisibleSearchResult', 'isVisibleTagSearchResult',
      'tagSearchFilterIndex', 'externalInputSearchKeyword' ]),
    getHeaderClass () {
      let headerClass = 'search-header'
      if (this.tagSearchKeywordList.length) {
        if (this.tagSearchFilterIndex === null) {
          headerClass = headerClass + ' with-tag-list'
        } else {
          headerClass = headerClass + ' with-tag-list with-filter'
        }
      } else if (this.isVisibleSearchResult) {
        headerClass = headerClass + ' with-search-tab-list'
      }
      return headerClass
    },
    getSearchResultClass () {
      let classes = 'search-result with-search-result-list'
      if (isNaverBrowser() && isTablet()) {
        classes += ' naver-in-ios'
      }
      return classes
    }
  },
  created () {
    // disableBodyScroll()
    this.originHeigth = window.innerHeight
    this.storage = getStorage()
    EventBus.$on('show-tag-search', () => this.showTagSearch())
    EventBus.$on('hide-tag-search', () => this.hideTagSearch())
    EventBus.$on('showRecommendTagKeyword', () => this.showRecommendTagKeyword())
    EventBus.$on('hideRecommendTagKeyword', () => this.hideRecommendTagKeyword())
    EventBus.$on('search-by-tag', this._onSearchByTag)
    EventBus.$on('search-by-recent-keyword', this._onSearchByRecentKeyword)
  },
  mounted () {
    if (this.tagSearchKeywordList.length > 0 && this.tagSearchFilterIndex !== null) {
      this.setSearchTagData()
      this.showTagSearchResult()
    }
    if (this.externalInputSearchKeyword.length) {
      this.searchKeyword = this.externalInputSearchKeyword
      this.$nextTick(() => {
        this.hideBottomMenu()
        this.hideRecommendTagKeyword()
        this.searchByKeyword()
      })
    }
    // disableBodyScroll()
    window.addEventListener('scroll', () => {
      this.scrollKeyboard(this.originHeigth)
    })
    // if (screenfull.enabled) {
    //   const el = document.querySelector('.search-view')
    //   screenfull.request(el)
    // }
  },
  beforeRouteLeave (to, from, next) {
    EventBus.$off('search-by-tag', this._onSearchByTag)
    EventBus.$off('search-by-recent-keyword', this._onSearchByRecentKeyword)
    enableBodyScroll()
    if (to.name === 'player' || to.name === 'list' || to.name === 'notice_view' || to.name === 'notice_list' || to.name === 'faq') {
      this.setExternalInputSearchKeyword(this.searchKeyword)
    } else {
      this.resetData()
    }
    this.$nextTick(() => {
      next()
    })
  },
  watch: {
    searchKeyword () {
      if (this.searchKeyword.length === 50) {
        utils.alert('최대 50자까지 입력 가능합니다. 글자수를 확인해주세요.')
      }
    },
    isVisibleTagSearch (isVisible) {
      if (isVisible) {
        if (this.$refs.searchInnerWrapper) {
          this.$refs.searchInnerWrapper.style.display = 'none'
        }
        if (this.$refs.searchHeader) {
          this.$refs.searchHeader.style.display = 'none'
        }
        if (this.$refs.bottomMenu) {
          this.$refs.bottomMenu.style.display = 'none'
        }
      } else {
        if (this.$refs.searchInnerWrapper) {
          this.$refs.searchInnerWrapper.style.display = 'block'
        }
        if (this.$refs.searchHeader) {
          this.$refs.searchHeader.style.display = 'block'
        }
        if (this.$refs.bottomMenu) {
          this.$refs.bottomMenu.style.display = 'block'
        }
      }
    }
  },
  beforeDestroy () {
    //태그검색 -> 콘텐츠 상세 -> 이전키로 복귀시 UI 오류 수정을 위해 주석처리
    //사이드 이펙트 발견되지 않았으나 추가로 발생할 여지는 있음
    //2020-01-22
    // this.hideTagSearchResult()
    // this.setTagSearchKeywordList([])
    window.removeEventListener('scroll', this.scrollKeyboard)
  }
}
</script>

<style scoped>
  .search-view{
    position: relative;
    /*top: 0;*/
    /*left: 0;*/
    /*min-height: 100vh;*/
  }

  .search-wrapper {
    /*position: relative;*/
    width: 100%;
    /*right: 0;*/
    /*bottom: 0;*/
    z-index: 3000;
    background-color: #1b1b1b;
    /*overflow-y: scroll;*/
    /*-webkit-overflow-scrolling: touch;*/
    /*overflow-scrolling: touch;*/
  }

  .search-wrapper::-webkit-scrollbar{
    display: none;
    background-color: transparent
  }
  .search-inner-wrapper {
    /*position: relative;*/
    width: 100%;
  }

  .search-header {
    width: 100%;
    position: fixed;
    /*position: absolute;*/
    /*position: sticky;*/
    /*position: -webkit-sticky;*/
    z-index: 4000;
    top: 0;
    left: 0;
    right: 0;

    height: 70px;
    overflow: hidden;
    background-color: #101010;
  }

  .search-header.with-tag-list {
    height: 210px;
  }
  .search-header.with-tag-list.with-filter {
    height: 170px;
  }
  .search-header.with-search-tab-list {
    height: 110px;
  }

  .button-area {
    position: absolute;
    width: 35px;
    height: 36px;
    left: 10px;
    top: 20px;
    margin-top: 4px;
    margin-left: 4px;
    z-index: 100;
  }

  .search-box-area {
    position: relative;
    width: 100%;
    padding-left: 52px;
    padding-right: 20px;
    height: 36px;
    top: 20px;
    box-sizing: border-box;
    overflow: visible;
  }

  .search-box-area input[type=text] {
    width: 100%;
    height: 36px;
    padding: 0 36px;
    -webkit-background-size: 20px 20px;
    color: #fff;
    background: #1b1b1b url("/img/common/ic_input_search.png") no-repeat 8px 8px;
    background-size: 20px 20px;
    -webkit-border-radius: 36px;
    -moz-border-radius: 36px;
    border-radius: 36px;
    font-size: 14px;
    line-height: 40px;
    vertical-align: middle;
    box-sizing: border-box;
  }
  .search-box-area input::placeholder{
    color: #a5a5a5;
  }
  .search-box-area input[type="text"]:focus{
    border: none;
    outline: none;
  }
  .search-box-area button.search-delete{
    position: absolute;
    top: 50%;
    margin-top: -13px;
    right: 20px;
    width: 40px;
    border-radius: 30px;
  }

  .search-box-area button.search-delete > img{
    width: 26px;
  }

  .search-box-area input[type=text]::placeholder {
    font-size: 14px;
    color: #ccc;
  }

  .tag-search-list {
    position: absolute;
    height: 100px;
    width: 100%;
    overflow-x: scroll;
    top: 70px;
    border-bottom: 2px #1b1b1b solid;
  }

  .search-result {
    position: relative;
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    z-index: 3000;
    padding-top: 70px;
    padding-bottom: 136px;
  }
  .search-result::-webkit-scrollbar{
    display: none;
    background-color: transparent
  }
  .search-result-intro:after{
    position: fixed;
    bottom: 126px;
    left: 0;
    display: block;
    content: '';
    width: 100%;
    height: 40px;
    background-image: -webkit-gradient(to bottom, rgba(27, 27, 27, 0), rgba(27, 27, 27, 0.8) 36%, #1b1b1b, rgba(27, 27, 27, 0.8));
    background-image: linear-gradient(to bottom, rgba(27, 27, 27, 0), rgba(27, 27, 27, 0.8) 36%, #1b1b1b, rgba(27, 27, 27, 0.8));

  }
  .search-result.with-tag-list {
    /*top: 210px;*/
    /*position: absolute;*/
    /*top: 0;*/
    /*bottom: 0;*/
    padding-top: 210px;
    padding-bottom: 0;
  }

  .search-result.with-tag-list.with-filter {
    /*top: 180px;*/
    top: 0;
    bottom: 0;
    padding-top: 180px;
  }

  .search-result.with-search-result-list {
    /*position: relative;*/
    /*top: 0;*/
    /*bottom: 0;*/
    padding-top: 110px;
    padding-bottom: 0;
  }

  .search-result.with-search-result-list.naver-in-ios{
    padding-bottom: 50px;
  }

  .search-bottom-menu {
    position: fixed;
    width: 100%;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 16px 0;
    overflow: hidden;
    z-index: 3000;
    background-color: #252525;
  }

  .search-list-wrapper {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background-color: #fff;
    z-index: 5000;
  }

  .tag-item {
    display: inline-block;
    position: relative;
    top: 10px;
    min-width: 61px;
    margin: 0 0 0 10px;
    padding: 5px 10px;
    text-align: center;
    color: #a5a5a5;
    font-size: 12px;
    line-height: 18px;
    border: 1px solid #a5a5a5;
    -moz-border-radius: 16px 16px 16px 16px;
    border-radius: 16px 16px 16px 16px;
  }

  .tag-item.selected {
    border: 2px solid #fff;
    font-weight: 700;
  }

  .header-tab {
    display: inline-block;
    position: relative;
    top: 10px;
    min-width: 61px;
    margin: 0 0 0 10px;
    padding: 0 10px 0 10px;
    height: 40px;
    text-align: center;
    color: #fff;
    font-size: 12px;
    line-height: 32px;
  }

  .tag-item-txt{
    display: inline-block;
    vertical-align: middle;
  }
  .delete-tag-icon {
    display: inline-block;
    vertical-align: middle;
    position: relative;
    width: 20px;
    height: 20px;
    right: -5px;
  }

  .flex-wrapper {
    width: max-content;
    height: 50px;
    overflow-x: scroll;
    padding: 0 10px 0 10px;
  }

  .tag-refresh {
    position: absolute;
    width: 100%;
    height: 44px;
    bottom: 45px;
  }

  .tag-refresh-button {
    position: relative;
    height: 24px;
    width: 100px;
    font-size: 12px;
    line-height: 24px;
    color: #a5a5a5;
    margin: 0 auto;
    padding-left: 20px;
    top: 10px;
    text-align: center;
    opacity: 0.6;
  }

  .tag-refresh-icon {
    position: absolute;
    left: 10px;
    top: 3px;
  }
</style>
